module.exports = "/static/assets/12398f42368ff5cc10c45a38bac8233a.png";